import { create } from 'zustand';

/**
 * Creatives still on their way to storage, counted per job.
 *
 * Module state rather than a mutation's, because the upload outlives the dialog that started
 * it: the reviewer is on the job page while the bytes are still going up. Pre-flight run in
 * that window looks for each creative's row, finds none yet, and reports every file still in
 * flight as never uploaded.
 */
const useCreativeUploads = create<Record<string, number>>(() => ({}));

/** Counts `count` creatives as uploading to this job, until the returned function is called. */
export function trackCreativeUploads(jobId: string, count: number): () => void {
  const shift = (by: number) =>
    useCreativeUploads.setState((state) => ({ [jobId]: (state[jobId] ?? 0) + by }));
  shift(count);
  return () => shift(-count);
}

export function useCreativesUploading(jobId: string): number {
  return useCreativeUploads((state) => state[jobId] ?? 0);
}
